import React from 'react';

import config from '../../config';

export default function Header() {
  return (
    <header id="header">
      <div className="logo-container">
        <img src="/bmi-logo.jpg" alt="BMI Logo" className="logo" />
      </div>
      <h1>{config.heading}</h1>
      <p>{config.subHeading1}</p>
      <p className="text-right">{config.subHeading2}</p>
    </header>
  );
}
